import { forwardRef } from 'react';
import { InputContainer } from './Input.styled';
import { useTranslate } from 'hooks/translation-hooks';
import { InputTypes } from './types';
import { noop } from 'utils/global-utils';
import { InputText } from '@integration/alexandria-ui';

const Input = forwardRef<any, InputTypes>(
  (
    {
      label,
      moreInfoLabel,
      placeholder,
      testId = 'input',
      error,
      autoComplete = 'on',
      children,
      onBlur = noop,
      onFocus = noop,
      required = true,
      textTransform = 'none',
      ...others
    },
    ref,
  ) => {
    const t = useTranslate('caseOpening');
    return (
      <InputContainer>
        <InputText
          label={label}
          placeholderMessage={placeholder}
          errorMessage={error && t(error)}
          optionalMessage={!required && t(`${testId}-label-optional`)}
          moreInfoMessage={moreInfoLabel}
          testId={testId}
          autoComplete={autoComplete}
          onBlur={onBlur}
          onFocus={onFocus}
          textTransform={textTransform}
          {...others}
          // @ts-ignore
          ref={ref}
        >
          {children}
        </InputText>
      </InputContainer>
    );
  },
);

export default Input;
